import { styled } from "@mui/material";
import { Chip as MuiChip } from "@mui/material"

export const Chip = styled(MuiChip)(({ theme: { palette } }) => ({
    height: "2rem",
    padding: "0.5rem 0.5rem 0.438rem 0.813rem",
    borderRadius: 12,
    border: `solid 1px ${palette.colors.purple.o70}`,
    backgroundColor: palette.colors.purple.o10,
    color: palette.colors.purple.o70,
    fontSize: "0.875rem",
    fontWeight: 500,
    "& .MuiChip-deleteIcon": {
        color: palette.colors.purple.o70,
        fontSize: "16px",
        margin: 0,
        "&:hover": {
            color: palette.colors.purple.o70,
        },
    },
    "& .MuiChip-label": {
        paddingLeft: 0,
    },
}));